'use client';
import React from 'react';

import Hooks from '@benzinga/hooks';
import { SessionContext } from '@benzinga/session-context';
import { ChartConfigManager } from '@benzinga/chart-config-manager';

export const useChartData = (guid: string) => {
  const session = React.useContext(SessionContext);

  const [chart, setChart] = React.useState(() => session.getManager(ChartConfigManager).getCachedChartData(guid));
  React.useEffect(() => {
    session.getManager(ChartConfigManager).getChartData(guid);
  }, [guid, session]);

  Hooks.useSubscriber(session.getManager(ChartConfigManager), event => {
    switch (event.type) {
      case 'chart-config:chart-updated':
        if (event.uuid === guid) {
          setChart(event.chart);
        }
        break;
    }
  });

  return chart;
};
